"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAccountNavigation = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _oneWeir = require("@weirgroup/one-weir");
var _userdetailsConstants = require("../userdetailsConstants");
var _mainModule = _interopRequireDefault(require("../main.module.css"));
class UserAccountNavigation extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [{
        name: this.props.mineSiteLabel.plural,
        link: _userdetailsConstants.userDetailsConstants.MINESITES_LINK
      }, {
        name: _userdetailsConstants.userDetailsConstants.USER_ACTIVITY,
        link: _userdetailsConstants.userDetailsConstants.USER_ACTIVITY_LINK
      }],
      SelectedLinkNav: this.props.SelectedLink
    };
  }
  renderNavItem(navItem, index) {
    return /*#__PURE__*/_react.default.createElement(_oneWeir.NavItem, {
      type: "innerNavItem",
      className: index === 0 ? _mainModule.default.paddingLeftNone : '',
      selected: this.props.SelectedLink.indexOf(navItem.link) >= 0,
      key: navItem.name,
      onClick: () => this.props.ChangeNavSelected(navItem)
    }, navItem.name);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_oneWeir.Navbar, {
      className: _mainModule.default.navbarShadow
    }, this.state.items.map((navItem, index) => this.renderNavItem(navItem, index)));
  }
}
const mapStateToProps = state => ({
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
const connectedUserAccountNavigation = exports.UserAccountNavigation = (0, _reactRedux.connect)(mapStateToProps)(UserAccountNavigation);